import {
  AloftPrice,
  PairedCostAdjustmentType,
  PairedCostSettingsJSON,
  isUndefined,
} from '@aloft/toolkit-shared';

import { priceJSONToPrice } from '../../utils/priceJSONToPrice.ts';

export function applyRoundingAndThresholds(
  adjustment: AloftPrice | undefined,
  adjustmentType: PairedCostAdjustmentType,
  settings: PairedCostSettingsJSON,
): AloftPrice | undefined {
  if (isUndefined(adjustment)) return undefined;

  const rounding = settings.enableRounding
    ? priceJSONToPrice(
        settings.rounding[adjustmentType] ?? settings.roundingDefault,
      )?.toDollarLike()
    : undefined;
  const threshold = settings.enableThreshold
    ? priceJSONToPrice(
        settings.threshold[adjustmentType] ?? settings.thresholdDefault,
      )?.toDollarLike()
    : undefined;

  const basis = adjustment.toDollarLike();
  const rounded = rounding !== undefined ? Math.round(basis / rounding) * rounding : basis;
  const thresholded = threshold !== undefined && Math.abs(rounded) < threshold ? 0 : rounded;

  return AloftPrice.fromDollarLike(thresholded, adjustment.currency);
}
